// import AudioPlayer from 'app/src/data/AudioPlayer';
// import VideoPlayer from 'app/src/data/VideoPlayer';
import {logDebug} from "./AppLog";
import {APP_GAME_AUDIO_URI} from "./services";

const AUDIO_PLAYER_STATE_NONE = 0;
const AUDIO_PLAYER_STATE_LOADED = 1;
const AUDIO_PLAYER_STATE_PLAYING = 2;
const AUDIO_PLAYER_STATE_WAITING = 3;

export const GAME_LOSE_AUDIO = 'game_lose.m4a';
export const GAME_PLAY_AUDIO = 'game_play.m4a';
export const GAME_CRUSH_AUDIO = 'game_crush.m4a';
export const GAME_TIMER_AUDIO = 'game_timer.m4a';
export const GAME_TIMER_LOW_AUDIO = 'game_timer_low.m4a';
export const GAME_WIN_AUDIO = 'game_win.m4a';
export const GAME_NEUTRAL_AUDIO = 'game_neutral.m4a';
export const GAME_SLOT_END_AUDIO = 'game_slot_4.m4a';
export const GAME_CARD_SHUFFLE_AUDIO = 'game_card_shuffle.m4a';
export const GAME_BOMB_AUDIO = 'game_bomb.m4a';
export const GAME_BG_AUDIO = 'game_bg.m4a';

export default class GameAudioPlayer {

  static instance = null;

  static getInstance() {
    if (GameAudioPlayer.instance == null) {
      GameAudioPlayer.instance = new GameAudioPlayer();
    }
    return GameAudioPlayer.instance;
  }

  constructor() {
    this.isMuted = true;
    this.assets = {};
    this.assetCounter = 0;

    window.addEventListener('click', () => {
      logDebug('windowClicked');
        this.unmute();
    }, {once: true})
  }

  unmute() {
    this.isMuted = false;
    const assetKeys = Object.keys(this.assets);
    assetKeys.forEach((assetKey) => {
      const asset = this.assets[assetKey];
      asset.audio.muted = false;
      if (asset.state === AUDIO_PLAYER_STATE_WAITING) {
        this.play(asset.id, asset.onPlayed, asset.release);
      }
    });
  }

  playAudio() {
    this.playInline(GAME_PLAY_AUDIO, true);
  }

  playWinAudio() {
    this.playInline(GAME_WIN_AUDIO, true);
  }

  playNeutralAudio() {
    this.playInline(GAME_NEUTRAL_AUDIO, true);
  }

  playLoseAudio() {
    this.playInline(GAME_LOSE_AUDIO, true);
  }

  playInline(url, fromResources = false) {
    this.load(url, (assetId) => {
      this.play(assetId, null, true);
    }, fromResources);
  }

  load(url, onLoaded, fromResources = false, inLoop = false) {
    // Sound.setCategory('Playback');
    // Sound.setMode('GameChat');

    if (!url.startsWith('https://') && !url.startsWith('blob:')) {
      url = APP_GAME_AUDIO_URI + url;
    }

    const assetId = ''+ ++this.assetCounter;
    const asset = {
      id: assetId,
      url: url,
      state: AUDIO_PLAYER_STATE_NONE
    };

    this.logMessage('GameAudioAdded', asset);

    const audio = new Audio(url);
    audio.muted = this.isMuted;
    if (inLoop) {
      audio.loop = true;
    }
    audio.loadListener = () => {
      this.logMessage('GameAudioLoaded', asset);

      asset.duration = audio.duration;
      if (onLoaded) {
        onLoaded(assetId);
      }
    };
    audio.loadErrorListener = () => {
      this.logMessage('GameAudioLoadFailed', asset);
      delete(this.assets[assetId]);
    };

    audio.addEventListener("loadeddata", audio.loadListener);
    audio.addEventListener("error", audio.loadErrorListener);

    asset.audio = audio;
    this.assets[assetId] = asset;
  }

  play(assetId, onPlayed, release = false) {
    const asset = this.assets[assetId];
    if (asset && asset.audio) {
      if (asset.state === AUDIO_PLAYER_STATE_PLAYING) {
        this.stop(assetId, () => {
          this.play(assetId, onPlayed, release);
        });
      } else if (this.isMuted) {
        asset.state = AUDIO_PLAYER_STATE_WAITING;
        asset.onPlayed = onPlayed;
        asset.release = release;
      } else {
        // AudioPlayer.getInstance().pauseCurrentTrack();
        // VideoPlayer.getInstance().pauseCurrent();

        delete asset.onPlayed;
        delete asset.release;
        asset.state = AUDIO_PLAYER_STATE_PLAYING;

        asset.audio.play().then(r => {
          const asset = this.assets[assetId];
          this.logMessage('GameAudioPlayed', asset);
          if (asset) {
            asset.state = AUDIO_PLAYER_STATE_LOADED;
            if (onPlayed) {
              onPlayed(1);
            }
            if (release) {
              this.release(assetId);
            }
          }
        }).catch((error) => {
          this.logMessage('GameAudioError', asset);
          logDebug('GameAudioError1' + asset.audio.muted, error);
        });
      }
    }
  }

  stop(assetId, onStop, release = false) {
    const asset = this.assets[assetId];
    if (asset && asset.audio) {

      asset.audio.pause();

      asset.state = AUDIO_PLAYER_STATE_LOADED;
      this.logMessage('GameAudioStopped', asset);
      setTimeout(() => {
        if (onStop) {
          onStop();
        }
        if (release) {
          this.release(assetId);
        }
      });
    }
  }

  release(assetId) {
    const asset = this.assets[assetId];
    if (asset && asset.audio) {
      asset.audio.removeEventListener("loadeddata", asset.audio.loadListener);
      asset.audio.removeEventListener("error", asset.audio.loadErrorListener);
      // asset.audio.release();
      this.logMessage('GameAudioReleased', asset);
      delete(this.assets[assetId]);
    }
  }

  logMessage(message, asset) {
    if (asset) {
      logDebug(message, {id: asset.id, url: asset.url, state: asset.state});
    }
  }
}
